import React from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { AdminFormSection } from '@ui';
import { useEffectOnce } from 'react-use';
import { UpdateTXUserFormValues } from '@/types/customer';
import { TXCenterMultiSelect } from './components/TXCenterMultiSelect';
import { UpdateRolesList } from './components/UpdateRolesList';

export const TXUserEditForm = React.memo(({ isReadOnly = false }: { isReadOnly?: boolean }) => {
  const { control, trigger } = useFormContext<UpdateTXUserFormValues>();

  const { fields, replace } = useFieldArray({
    control,
    name: 'customerInTxCenters',
  });

  useEffectOnce(() => {
    trigger('email');
  });

  return (
    <AdminFormSection title="TX Center(s)" isReadOnly={isReadOnly} type="user">
      <TXCenterMultiSelect isReadOnly={isReadOnly} replace={replace} />
      <UpdateRolesList isReadOnly={isReadOnly} fields={fields} />
    </AdminFormSection>
  );
});

TXUserEditForm.displayName = 'TXUserEditForm';
